import axios from "axios";
import { API_BASE_URL } from "../../config";

// Planung korrigiert oder löscht Stempelungen (Erfasste Arbeitszeit, Genehmigungen).
const authHeaders = () => ({ Authorization: `Bearer ${localStorage.getItem("session_token")}` });

export const updatePunchEntry = (id, payload) =>
  axios.put(`${API_BASE_URL}/api/web/reporting/${id}`, payload, { headers: authHeaders() });

export const deletePunchEntry = (id) =>
  axios.delete(`${API_BASE_URL}/api/web/reporting/${id}`, { headers: authHeaders() });
